<template>
  
  <div class="">
    <app-header/>
    
    <div class="container">

      <div class="row">
        
        <div class="col-sm-12">
          <div class="box-dashboard">
            <div class="bd-header">
              Total Consignaciones
            </div>

            <div class="bd-body expo">
              <h2>${{money(total)}}</h2>
              <p>Dinero en recaudos</p>
            </div>
          </div>
        </div>

      
      </div>

      <div class="float-right">
        <button type="button" v-b-modal.modalFilter class="btn btn-primary">
          Filtrar
        </button>
      </div>

      <div class="d-inline mr-4">
        <button type="button" v-b-modal.reportConsignment class="btn btn-primary">
          Reportar Consignación
        </button>
      </div>

      <div class="d-inline">
        <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
          CSV
        </button>
      </div>

      <div class="table table-padded">

      <b-card>
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group horizontal label="Buscador" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>


          <b-col md="6" class="my-1">
            <b-form-group horizontal label="Por página" class="mb-0">
                  <b-form-select :options="pageOptions" v-model="perPage" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
              
             :items="consignments"
             :fields="fields"
             :current-page="currentPage"
             :per-page="perPage"
             :filter="filter"
              @filtered="onFiltered" class="table table-padded">

             <template slot="status" slot-scope="row">
               <template v-if="row.item.status == 2">
                  Aprobada
                </template>
                <template v-else-if="row.item.status == 1">
                  Pendiente
                </template>
                <template v-else>
                  Rechazada
                </template>
             </template>

             <template slot="type" slot-scope="row">
                <template v-if="row.item.eTransfer == 1">
                  Transferencia
                </template>

                <template v-else>
                  Consignación
                </template>

                 
               </template>

             <template slot="createdAt" slot-scope="row">
               {{row.item.createdAt.substr(0, 10)}}
             </template>

             <template slot="createdAtHour" slot-scope="row">
               {{row.item.createdAt.substr(11, 5)}}
             </template>

             <template slot="date" slot-scope="row">
               {{row.item.date.substr(0, 10)}}
             </template>

             <template slot="hour" slot-scope="row">
               {{row.item.date.substr(11, 5)}}
             </template>

             <template slot="bankImage" slot-scope="row">
                <img :src="'/banks/'+row.item.bankImage" class="bank">
             </template> 

             <template slot="amount" slot-scope="row">
              <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.amount)}}</h2>
             </template>

            <template slot="anexo" slot-scope="row">
              <img :src="'/banks/'+row.item.image" class="bank">             
            </template>


          <!-- <thead>
            <tr>
              <th>{{$t('table.status')}}</th>
              <th>{{$t('table.date')}}</th>
              <th>{{$t('table.hour')}}</th>
              <th>{{$t('table.reference')}}</th>
              <th>{{$t('table.dateConsignment')}}</th>
              <th>{{$t('table.hourConsignment')}}</th>
              <th>{{$t('table.bank')}}</th>
              <th>{{$t('table.value')}}</th>
              <th>{{$t('table.anexo')}}</th>
            </tr>
          </thead> -->
          <!-- <tbody>
            <tr v-for="(consignment, index) in consignments" :key="index">
              <td>
                <template v-if="consignment.status == 2">
                  Aprobada
                </template>
                <template v-else-if="consignment.status == 1">
                  Pendiente
                </template>
                <template v-else>
                  Rechazada
                </template>
              </td>
              <td>{{consignment.createdAt.substr(0, 10)}}</td>
              <td>{{consignment.createdAt.substr(11, 5)}}</td>
              <td>{{consignment.reference}}</td>
              <td>{{consignment.date.substr(0, 10)}}</td>
              <td>{{consignment.date.substr(11, 5)}}</td>
              <td>
                <img :src="'/banks/'+consignment.bankImage" class="bank">
              </td>
              <td>
                
              </td>
              <td>
                <img :src="'/banks/'+consignment.image" class="bank">
              </td>
            </tr>
          </tbody> -->
        </b-table>

        <b-row>
          <b-col md="12" class="my-1 float-right">
            <b-pagination :total-rows="consignments.length" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>

        <app-pagination :data="data"/>


        
      </b-card >

    </div>

    </div>
      
    <app-footer/>

  <b-modal id="modalFilter" ref="modalFilter" title="Filtrar" hide-footer>
    
    <form v-on:submit.prevent="read">
      <div class="form-group">
        <label>Referencia de pago</label>
        <input type="text" class="form-control" v-model="filters.payReference">
      </div>

      <div class="form-group">
        <label>Fecha Inicial</label>
        <input type="date" class="form-control" v-model="filters.dateStart">
      </div>

      <div class="form-group">
        <label>Fecha Final</label>
        <input type="date" class="form-control" v-model="filters.dateEnd">
      </div>

      <div class="form-group">
        <label>Banco</label>
        <select class="form-control" v-model="filters.bankId">
              <option v-for="(bank, index) in banks" :key="index" :value="bank.id">
                {{bank.name}}
              </option>
        </select>
      </div>

      <div class="form-group">
          <label class='control-label'>Estado</label>
          <select class="form-control" v-model="filters.status">
            <option value="1" >Pendiente</option>
            <option value="2" >Aprobada</option>
            <option value="0" >Rechazada</option>
          </select> 
        </div>

      <div class="d-inline mr-4">
            <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
            </button>
      </div>
      <div class="d-inline">
        <button type="submit" class="btn btn-primary">Filtrar</button>
      </div>
    </form>
  </b-modal>

  <b-modal id="reportConsignment" ref="reportConsignment" title="Reportar Consignación" @ok="reportConsignment()">

    <form v-on:submit.prevent="reportConsignment">
      <div class="form-group">
        <label>Tarjeta de Recaudo</label>
        <input type="text" class="form-control" v-model="report.reference">
      </div>

      <div class="form-group">
        <label>Fecha Consignación</label>
        <input type="date" class="form-control" v-model="report.dateConsignment">
      </div>

      <div class="form-group">
        <label>Hora Consignación</label>
        <input type="time" step="1" class="form-control" v-model="report.hourConsignment">
      </div>


      <div class="form-group">
        <label>Banco</label>
        <select class="form-control" v-model="report.bankId">
              <option v-for="(bank, index) in banks" :key="index" :value="bank.id">
                {{bank.name}}
              </option>
        </select>
      </div>

      <div class="form-group">
        <label>Valor</label>
        <money  v-model="report.value" class="form-control"></money>
      </div>

      <div class="form-group">
        <label>Anexo</label>
        <input type="file" class="form-control" >
      </div>

      <div class="form-group">
        <label>Observación</label>
        <input type="text" class="form-control" v-model="report.observation">
      </div>

      
    </form>

  </b-modal>



  </div>
</template>


<script>
import { mapGetters } from "vuex";
import {
  FETCH_CONSIGNMENTS,
  FETCH_BANKS,
  REPORT_CONSIGNMENT
} from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      filters: {
        payReference: "",
        reportDate: "",
        user: "",
        bankId: ""
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      report: {},
      data: {},
      fields: [
        { key: "status", label: "Estado", sorteable: true },
        { key: "type", label: "Tipo", sorteable: true },
        { key: "createdAt", label: "Fecha", sorteable: true },
        { key: "createdAtHour", label: "Hora", sorteable: true },
        { key: "reference", label: "Referencia", sorteable: true },
        { key: "date", label: "Fecha consignación", sorteable: true },
        { key: "hour", label: "Hora consignación", sorteable: true },
        { key: "bankImage", label: "Imagen", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "anexo", label: "Anexo", sorteable: true }
      ]
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    read() {
      this.$refs.modalFilter.hide();
      this.$store.dispatch(FETCH_CONSIGNMENTS, this.filters);
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },
    reportConsignment() {
      this.$store
        .dispatch(REPORT_CONSIGNMENT, this.report)
        .then(result => {
          this.report = {};
          this.read();
          this.$refs.reportConsignment.hide();
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    generateCVS() {
      var total = 0;
      var rows = this.consignments.map(item => {
        var status = "";
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else {
          status = "Rechazada";
        }

        total += item.amount;
        return [
          item.id,
          status,
          item.createdAt.substr(0, 10),
          item.createdAt.substr(11, 5),
          "#" + item.reference,
          item.date.substr(0, 10),
          item.date.substr(11, 5),
          item.bankName,
          "$" + item.amount
        ];
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Referencia Pago",
          "Fecha Consignacion",
          "Hora Consignación",
          "Banco",
          "Valor"
        ],
        ...rows,
        ["", "", "", "", "", "", "", "TOTAL:", "$" + total]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Consignaciones.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["user", "consignments", "banks"]),
    total: function() {
      var total = 0;
      this.consignments.map(row => (total += row.amount));
      return total;
    }
  },

  mounted() {
    this.read();
    this.$store.dispatch(FETCH_BANKS);
  }
};
</script>


<style lang="scss">
</style>
